module.exports = __webpack_public_path__ + "img/38659-002.361ae74a.jpg";